import type { RowSelectionState } from "@tanstack/react-table";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Disclosure } from "@/components/Disclosure";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Breadcrumb } from "@/components/Breadcrumb";
import { TablaOPEs } from "./TablaOPEs";
import { useState } from "react";
import Select, { type SingleValue } from "react-select";
import { Loading, QueryError } from "@/components/Loading/Loading";
import { notificacionTipo } from "@/components/Alerts";
import { ModalConfirmar } from "@/components/modals/Confirmar";

export function ListadoOPEPage() {
	const [filtroProveedor, setFiltroProveedor] = useState("");
	const [selectedOPEs, setSelectedOPEs] = useState<RowSelectionState>({});
	const queryClient = useQueryClient();
	const [opesACerrar, setOpesACerrar] = useState<string[]>([]);


	const onCerrarOFsSeleccionadas = () => {
		const opesACerrar = Object.entries(selectedOPEs).map(([id, _]) => id);

		if (opesACerrar.length === 0) {
			notificacionTipo("warning", "No hay OFs seleccionadas.");
			return;
		}

		setOpesACerrar(opesACerrar);
	};



	return (
		<div id="content" className="content" >
			<title>Piher | Listado de OPEs</title>
			{/*Content*/}
			<Breadcrumb
				sectionTitle="Listado de OPEs"
				links={[
					{ label: "Listado de OPEs", active: true }
				]}
			/>


			<Disclosure style={{ marginBottom: 20 }}>
				{/* First element is the summary, second is the content */}
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<FiltroProveedores
					proveedor={filtroProveedor}
					setProveedor={setFiltroProveedor}
				/>
			</Disclosure>


			<h1>Líneas de OPE abiertas</h1>
			<div className="table-responsive">
				<TablaOPEs
					filtroProveedor={filtroProveedor}
					selected={selectedOPEs}
					setSelected={setSelectedOPEs}
				/>
			</div>

			<div className="contenedorBotones" style={{ marginTop: 20 }}>
				<button className="btnPrimary" onClick={onCerrarOFsSeleccionadas} type="button">
					Archivar OPEs seleccionadas
				</button>
			</div>


			<ModalConfirmar
				show={opesACerrar.length > 0}
				close={() => setOpesACerrar([])}
				message={`¿Está seguro de que desea archivar ${opesACerrar.length} OPEs de forma permanente?`}
				onConfirm={() => {
					void sendAjaxRequest<ResCerrarOPEs>("POST", "/api/v1/cerrarOPEs", {
						idOPEs: opesACerrar,
					}).then((res) => {
						if (res.status == "success") {
							notificacionTipo("success", res.message);
							setOpesACerrar([]);
						} else {
							notificacionTipo("error", res.message);
						}

						return queryClient.invalidateQueries({ queryKey: ["getLineasOPE"] });

					});
				}}
			/>
		</div>
	);
};

function FiltroProveedores(props: { readonly proveedor: string; readonly setProveedor: (value: string) => void; }) {
	const { data, error, isPending } = useProveedores("OPE");

	if (error) return <QueryError error={error} fallback="Error al cargar los proveedores" />;
	if (isPending) return <Loading />;

	const options = data.map(prov => ({ value: prov.idProveedor, label: `${prov.idProveedor} - ${prov.nombre}` }));

	const value = options.find(opt => opt.value === props.proveedor);
	const setValue = (newValue: SingleValue<{ value: string; label: string; }>) => {
		props.setProveedor(newValue?.value ?? "");
	};

	return (
		<div className="contenedorFiltros" role="tabpanel">
			<label style={{ fontSize: 17 }}>
				Proveedores:
			</label>
			<br />
			<Select
				options={options}
				className=""
				value={value}
				onChange={setValue}

				isClearable
			/>
		</div>
	);
}

export function useOPEs() {
	return useQuery<LineaOPEPendiente[]>({
		queryKey: ["getLineasOPE"],
		queryFn: () => {
			const url = "/api/v1/getLineasOPE";
			return sendAjaxRequest<LineaOPEPendiente[]>("GET", url);
		},
	});
}
export function useProveedores(tipo: string) {
	return useQuery<Proveedor[]>({
		queryKey: ["getProveedores", tipo],
		queryFn: () => {
			const url = "/api/v1/getProveedores";
			return sendAjaxRequest<Proveedor[]>("GET", url, { tipo });
		},
	});
}
export interface Proveedor {
	idProveedor: string,
	nombre: string;
}
export interface LineaOPEPendiente {
	idProveedor: string;
	nombreProveedor: string;

	idOPE: number;
	idLineaOPE: number;

	idOF: number | null;
	idFaseOF: number | null;

	idConjunto: string;
	descConjunto: string;
	loteConjunto: string;

	cantidadFabricar: number;
	cantidadRecibida: number;
	percentEnviada: number;
}

export interface ResCerrarOPEs {
	status: string;
	message: string;
}